function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M39.1775+350.396L24.8454+322.878L13.0931+232.012L35.7378+171.244L31.4382+115.349L50.9298+53.1479L81.6005+84.6785L91.0597+109.043L94.9416+95.9368L148.961+95.5709L176.545+99.7048L187.834+95.3265L286.929+96.0273L294.845+100.043L304.023+96.2336L360.832+96.2131L365.896+304.6L361.67+342.199L342.471+344.399L338.489+339.893L340.952+348.172L291.709+358.708L287.983+374.187L200.27+380.206L197.117+367.021L115.692+367.041L121.665+356.783L49.7832+355.269L54.0829+344.09L39.1775+350.396Z",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M352.476+50.3833L375.011+27.3417L388.431+38.9891L389.697+374.484L372.733+371.699L353.489+353.974L350.451+219.27L352.223+208.382L349.185+61.7774L352.476+50.3833Z",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M83.7477+314.034L94.408+304.066L347.917+304.995",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M60.7349+338.438L79.6881+318.263",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M199.322+355.518L199.025+345.05L202.428+340.359L269.703+339.993L279.027+358.395",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M144.129+311.984L124.002+351.848",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M93.8963+297.207L93.8963+196.944L98.0822+183.988L93.8963+180.799L93.8963+119.406",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M338.239+320.846L324.948+320.548L323.225+323.165L332.387+332.55",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M127.878+137.869L132.949+131.108",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M147.036+255.914L151.825+262.394",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M166.539+237.191L167.888+243.711",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

function SvgRightA(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightA);
export default __webpack_public_path__ + "static/media/right-a.c1715b78.svg";
export { ForwardRef as ReactComponent };